module.exports = __webpack_public_path__ + "theme/assets/img/5201adeada0e716b0fe53c2b962a0f52.png";